import GenericColumn from '@isceco/widget-library2/basic-elements/List/column/GenericColumn.js'
import DateColumn from '@isceco/widget-library2/basic-elements/List/column/DateColumn.js'
import StringColumn from '@isceco/widget-library2/basic-elements/List/column/StringColumn.js'
import StringCell from '@isceco/widget-library2/basic-elements/List/cell/StringCell'
import ButtonCell from '@isceco/widget-library2/basic-elements/List/cell/ButtonCell'
import OptionalButtonCell from "../../components/StaticDetailList/OptionalButtonCell";

export default class EinladungColumns {

  static getColumnsWithDownload(deleteCallback, einladungDownloadCallback) {
    const columns = EinladungColumns.getColumns(deleteCallback)
    return [
      ...columns.slice(0, columns.length - 1),
      EinladungColumns.ACTIONS_COLUMN_DOWNLOAD(einladungDownloadCallback),
      columns[columns.length - 1]
    ]
  }

  static getColumns(deleteCallback) {
    return [
      EinladungColumns.TOKEN_COLUMN(),
      EinladungColumns.EMAIL_COLUMN(),
      EinladungColumns.EINLADUNGSDATUM_COLUMN(),
      EinladungColumns.GUELTIG_BIS_COLUMN(),
      EinladungColumns.STATUS_COLUMN(),
      EinladungColumns.ACTIONS_COLUMN(deleteCallback)
    ]
  }

  static TOKEN_COLUMN() {
    return new StringColumn({
      key: 'token',
      text: 'einladung.header.token'
    })
  }

  static EMAIL_COLUMN() {
    return new StringColumn({
      key: 'empfaenger',
      weight: 2,
      text: 'einladung.header.empfaenger',
      sortable: true
    })
  }

  static EINLADUNGSDATUM_COLUMN() {
    return new DateColumn({
      key: 'createdAt',
      text: 'einladung.header.createdAt',
      sortable: true
    })
  }

  static GUELTIG_BIS_COLUMN() {
    return new DateColumn({
      key: 'validUntil',
      text: 'einladung.header.validUntil',
      sortable: true
    })
  }

  static STATUS_COLUMN() {
    return new GenericColumn({
      key: 'status',
      text: 'einladung.header.status',
      sortable: true,
      cell: new StringCell({translate: true})
    })
  }

  static ACTIONS_COLUMN_DOWNLOAD(callback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new OptionalButtonCell({
        icon: 'file pdf',
        variant: 'primary',
        callback: row => callback(row),
        show: row => row.isBrief
      })
    })
  }

  static ACTIONS_COLUMN(callback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new ButtonCell({
        icon: 'trash',
        variant: 'danger',
        callback: row => callback(row)
      })
    })
  }
}
